module.exports = __webpack_public_path__ + "assets/webgl/Ceramic_base.1001.jpg.pvr.2e90dbec.ktx";